<template>
	<form @submit.prevent="save">
		<b-loading :active="isLoading"></b-loading>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Dodawanie zamówienia</p>
				<button
					type="button"
					class="delete"
					aria-label="close"
					@click="$parent.$emit('close')"
				></button>
			</header>
			<section class="modal-card-body">
				<div class="group">
					<div class="field field--client-name is-horizontal">
						<div class="field-label">Nazwa klienta:</div>
						<editable
							:isEditMode="true"
							:value="order.clientName"
							required
							placeholder="Imię Nazwisko / Nazwa firmy"
							type="text"
							@input="order.clientName = $event"
						/>
					</div>
					<div class="field field--client-phone is-horizontal">
						<div class="field-label">Telefon:</div>
						<editable
							:isEditMode="true"
							:value="order.phone"
							required
							placeholder="600-123-123"
							type="text"
							@input="order.phone = $event"
						/>
					</div>
					<div class="field field--client-postcode is-horizontal">
						<div class="field-label">Kod pocztowy:</div>
						<editable
							:isEditMode="true"
							:value="order.postalCode"
							required
							placeholder="00-000"
							type="text"
							@input="order.postalCode = $event"
						/>
					</div>
					<div class="field field--client-post is-horizontal">
						<div class="field-label">Poczta:</div>
						<editable
							:isEditMode="true"
							:value="order.post"
							required
							placeholder="Poczta"
							type="text"
							@input="order.post = $event"
						/>
					</div>
					<div class="field field--client-post is-horizontal">
						<div class="field-label">Kraj:</div>
						<b-field class="field-body" grouped>
							<b-select placeholder="Wybierz kraj" v-model="order.country" expanded required>
								<option value="PL">Polska</option>
								<option value="CZ">Czechy</option>
								<option value="SK">Słowacja</option>
								<option value="RO">Rumunia</option>
								<option value="HU">Węgry</option>
								<option value="DE">Niemcy</option>
								<option value="AT">Austria</option>
								<option value="HR">Chorwacja</option>
							</b-select>
						</b-field>
					</div>
					<hr />
					<div class="field field--client-broker is-horizontal">
						<div class="field-label">Pośrednik:</div>
						<editable
							:isEditMode="true"
							:value="order.broker"
							required
							disabled
							placeholder="Nazwa pośrednika"
							type="text"
							@input="order.broker = $event"
						/>
					</div>
					<hr />
					<div class="field field--client-currency is-horizontal">
						<div class="field-label">Waluta:</div>
						<b-field class="field-body" grouped>
							<b-select placeholder="Wybierz walutę" v-model="order.currency" expanded required>
								<option value="PLN">polski złoty</option>
								<option value="CZK">korona czeska</option>
								<option value="EUR">euro</option>
								<option value="RON">lej rumuński</option>
								<option value="HUF">forint</option>
							</b-select>
						</b-field>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button type="submit" class="button is-success button--add">
					<i class="mdi">save</i> Dodaj
				</button>
				<button
					class="button is-white button--cancel"
					type="button"
					@click="$parent.$emit('close')"
				>
					Anuluj
				</button>
			</footer>
		</div>
	</form>
</template>

<script>
import bus from '@/EventBus'
import { mapGetters } from 'vuex'
import EditableField from '@/components/EditableField'

export default {
	name: 'NewOrderModal',
	components: {
		editable: EditableField
	},
	data() {
		return {
			order: {},
			isLoading: false
		}
	},
	computed: {
		...mapGetters('auth', ['user'])
	},
	created() {
		this.order.broker = (this.user && this.user.name) || ''
	},
	methods: {
		save() {
			this.isLoading = true
			this.$store.dispatch('orders/createOrder', { order: this.order }).then((order) => {
				this.isLoading = false
				this.$store.dispatch('modals/hideNewOrderModal')
				this.$store.dispatch('modals/showViewOrderModal', true)
				this.$snackbar.open(`Zamówienie #${order.id} zostało dodane.`)
				bus.$emit('order-created')
			})
		}
	}
}
</script>
